module.exports = __webpack_public_path__ + "static/Coinwai-26a461e78c85140213a30a255653c96f.png";